import { saveAs } from 'file-saver'
import { isString } from 'src/typeGuards'

import { generateFile, subscribe } from './channels/download'

function getFileName (id: string) {
  switch (id) {
    case 'MailingExistingCustomersTable':
      return 'mailing_existing_customers_table.csv'
    case 'MailingExistingBankEmployeesTable':
      return 'mailing_existing_bank_employees_table.csv'
    case 'MailingExistingCreditAgencyUsersTable':
      return 'mailing_existing_credit_agency_users_table.csv'
    case 'VreBonusTable':
      return 'vre_bonus_table.csv'
    default:
      return 'file'
  }
}

$(() => {
  document.querySelectorAll<HTMLAnchorElement>('a.actionCableDownloader').forEach(downloader => {
    downloader.addEventListener('click', event => {
      event.preventDefault()

      const spinner = downloader.querySelector<HTMLLIElement>('i.actionCableSpinner')

      spinner?.classList?.remove('hidden')
      subscribe({
        onConnect (uuid) {
          generateFile(uuid, downloader.href)
        },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        onData ({ company_id, csv, scope }) {
          spinner?.classList?.add('hidden')

          if (company_id) {
            const url = `/credit_agency_users/companies/${company_id as string}` +
                        `/companies_data?scope=${scope}`

            window.location.href = url
          }

          const fileName = getFileName(downloader.id)

          if (isString(csv)) {
            return saveAs(new Blob([ csv ], { type: 'text/csv;charset=utf-8' }), fileName)
          }
        },
      })

      return false
    })
  })
})
